<template>
	<span class="d-flex">
		<menu-icon
			name="station_view_report"
			color="currentColor"
			edge-size="18"
			class="me-2"
		/>
		Користувач "<span class="fw-bolder">{{ writer }}</span>"
	</span>
	<span>
		створив <span v-html="taskJobDescription"></span>
	</span>
</template>




<script>
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import { useAccontStore } from '@/stores/AccountStore.js'
import { rpcTaskSchema, } from '@/composables/rpcTasks.js'
import {
	capitalizeFirstLetter,
	dateTimeToString,
} from '@/helpers.js'


export default {
	components: {
		MenuIcon,
	},

	props: {
		[rpcTaskSchema.job.key]: {
			type: String,
			required: true,
		},

		[rpcTaskSchema.context.key]: {
			type: Object,
			required: true,
		},

		[rpcTaskSchema.senderId.key]: {
			type: String,
			required: true,
		},

		[rpcTaskSchema.state.key]: {
			type: String,
			required: true,
		},

		// There is more RPC parameters ... Look to rpcTaskSchema
	},

	setup() {
		const accountStore = useAccontStore()

		return {
			rpcTaskSchema,
			capitalizeFirstLetter,
			accountStore,
		}
	},

	methods: {
	},

	computed: {
		context() {
			return this.$props[rpcTaskSchema.context.key]
		},

		writer() {
			const writer = this.context[rpcTaskSchema.context.writer.key]
				? this.context[rpcTaskSchema.context.writer.key][rpcTaskSchema.context.writer.name.key]
				: undefined
			const organization = writer 
				? this.context[rpcTaskSchema.context.writer.key][rpcTaskSchema.context.writer.organization.key][rpcTaskSchema.context.writer.organization.name.key]
				: undefined
			return `${writer ?? '-'}` + ((this.accountStore.isPrimary && organization) ? ` (${organization})` : '')
		},

		taskJobDescription() {
			const job = this.$props[rpcTaskSchema.job.key]
			const from = this.context[rpcTaskSchema.context.from.key]
			const to = this.context[rpcTaskSchema.context.to.key]

			switch(job) {
				case rpcTaskSchema.job.allowed.buildStationReport.key:
					return `${rpcTaskSchema.job.allowed.buildStationReport.title} `
						+ `з&nbsp;${dateTimeToString(from)}&nbsp;`
						+ `по&nbsp;${dateTimeToString(to)}`
				case rpcTaskSchema.job.allowed.buildOrganizationReport.key:
					if (this.context[rpcTaskSchema.context.isAllOrganizations.key]) {
						return `звіт по всім організаціям `
							+ `з&nbsp;${dateTimeToString(from)}&nbsp;`
							+ `по&nbsp;${dateTimeToString(to)}`
					} else {
						return `${rpcTaskSchema.job.allowed.buildOrganizationReport.title} `
							+ `з&nbsp;${dateTimeToString(from)}&nbsp;`
							+ `по&nbsp;${dateTimeToString(to)}`
					}
				default:
					return 'невідомо'
			}
		},
	},
}
</script>